// The human message inside an API refusal. Atlantis answers both
// `{ message }` and `{ error: { message } }` (the promo creation flow in
// Promos.js already reads both); a bare string body is the API Gateway
// default. Nothing found → the caller's fallback.
export const apiErrorMessage = (error, fallback = null) => {
  const body = error?.response?.data;
  return (
    body?.error?.message ??
    body?.message ??
    (typeof body === 'string' && body.trim() ? body : null) ??
    fallback
  );
};
